<!--_____________________ROUTE_____________________-->
<ng-container *ngIf="route">
    <div class="title">
        {{'SHARED.ROUTE.LINKS.COMPONENT.TITLE' | translate}}
    </div>

    <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.EXTERNAL.CAPTION' | translate}}</div>
    <div class="link-with-copy">
        <button-link class="line left" (linkClick)="onClickLinkOption('terceros', null, null)">
            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.EXTERNAL.RESERVATIONSINGLE' | translate }}
        </button-link>
        <shared-copyclipboard [value]="getLink('terceros')"></shared-copyclipboard>
    </div>

    <ng-container *ngIf="shipments && shipments.length > 0">
        <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.CAPTION' | translate}}</div>

        <div *ngIf="shipments && shipments.length > 1">
            <div *ngFor="let item of shipments" class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('track', item, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.TRACKING' | translate:{ shipmentKey:
                    getString(item.shipmentKey),
                    originSkinAddress: getString(item.originSkinAddress),
                    destinationSkinAddress: getString(item.destinationSkinAddress) } }}
                </button-link>
                <shared-copyclipboard [value]="getLink('track', item)"></shared-copyclipboard>
            </div>
        </div>

        <div *ngIf="shipments && shipments.length == 1">
            <div *ngFor="let item of shipments" class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('track', item, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.TRACKINGSINGLE' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('track', item)"></shared-copyclipboard>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="totemRoute">
        <div class="normal-title" *ngIf="showTotemTitle">{{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.CAPTION' |
            translate}}
        </div>

        <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.CAPTION' | translate}}</div>
        <div class="link-with-copy">
            <button-link class="line left" (linkClick)="goTo(totemRoute.totemIdRoute)">
                {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFY' | translate }}
            </button-link>
            <shared-copyclipboard [value]="totemRoute.totemIdRoute"></shared-copyclipboard>
        </div>
        <div class="link-with-copy">
            <button-link class="line left" (linkClick)="goTo(totemRoute.totemIdRouteEnter)">
                {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.ENTRY' | translate }}
            </button-link>
            <shared-copyclipboard [value]="totemRoute.totemIdRouteEnter"></shared-copyclipboard>
        </div>
        <div class="link-with-copy">
            <button-link class="line left" (linkClick)="goTo(totemRoute.totemIdRouteExit)">
                {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.EXIT' | translate }}
            </button-link>
            <shared-copyclipboard [value]="totemRoute.totemIdRouteExit"></shared-copyclipboard>
        </div>
        <div class="link-with-copy">
            <button-link class="line left" (linkClick)="goTo(totemRoute.totemIdRouteSign)">
                {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.SIGN' | translate }}
            </button-link>
            <shared-copyclipboard [value]="totemRoute.totemIdRouteSign"></shared-copyclipboard>
        </div>
        <div class="link-with-copy">
            <button-link class="line left" (linkClick)="goTo(totemRoute.totemIdRouteNoSlot)">
                {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFYNOSLOT' | translate }}
            </button-link>
            <shared-copyclipboard [value]="totemRoute.totemIdRouteNoSlot"></shared-copyclipboard>
        </div>
        <div class="link-with-copy">
            <button-link class="line left" (linkClick)="goTo(totemRoute.totemIdRouteNoPlates)">
                {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFYNOPLATE' | translate }}
            </button-link>
            <shared-copyclipboard [value]="totemRoute.totemIdRouteNoPlates"></shared-copyclipboard>
        </div>
        <div class="link-with-copy">
            <button-link class="line left" (linkClick)="goTo(totemRoute.totemIdRouteNoSlotNoPlates)">
                {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFYNOSLOTNOPLATE' | translate }}
            </button-link>
            <shared-copyclipboard [value]="totemRoute.totemIdRouteNoSlotNoPlates"></shared-copyclipboard>
        </div>



        <ng-container *ngIf="phases">
            <div class="phase links-totem" *ngFor="let item of phases">
                <shared-active-slots-item-phase [phase]="item"
                    class="line noStatus noTags noDocks noAddress noGoods noVerificationCode"></shared-active-slots-item-phase>
                <ng-container *ngIf="item.totemPhase != null">
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="goTo(item.totemPhase.totemIdPhase)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFY' | translate }}
                        </button-link>
                        <shared-copyclipboard [value]="item.totemPhase.totemIdPhase"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="goTo(item.totemPhase.totemIdPhaseEnter)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.ENTRY' | translate }}
                        </button-link>
                        <shared-copyclipboard [value]="item.totemPhase.totemIdPhaseEnter"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="goTo(item.totemPhase.totemIdPhaseExit)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.EXIT' | translate }}
                        </button-link>
                        <shared-copyclipboard [value]="item.totemPhase.totemIdPhaseExit"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="goTo(item.totemPhase.totemIdPhaseSign)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.SIGN' | translate }}
                        </button-link>
                        <shared-copyclipboard [value]="item.totemPhase.totemIdPhaseSign"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="goTo(item.totemPhase.totemIdPhaseNoSlot)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFYNOSLOT' | translate }}
                        </button-link>
                        <shared-copyclipboard [value]="item.totemPhase.totemIdPhaseNoSlot"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="goTo(item.totemPhase.totemIdPhaseNoPlates)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFYNOPLATE' | translate }}
                        </button-link>
                        <shared-copyclipboard [value]="item.totemPhase.totemIdPhaseNoPlates"></shared-copyclipboard>
                    </div>
                    <div class="link-with-copy">
                        <button-link class="line left" (linkClick)="goTo(item.totemPhase.totemIdPhaseNoSlotNoPlates)">
                            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFYNOSLOTNOPLATE' | translate }}
                        </button-link>
                        <shared-copyclipboard
                            [value]="item.totemPhase.totemIdPhaseNoSlotNoPlates"></shared-copyclipboard>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</ng-container>

<!--_____________________PHASE_____________________-->
<ng-container *ngIf="phase">
    <div class="title">
        {{'SHARED.PHASE.LINKS.COMPONENT.TITLE' | translate}}
    </div>

    <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.EXTERNAL.CAPTION' | translate}}</div>
    <div class="link-with-copy">
        <button-link class="line left" (linkClick)="onClickLinkOption('terceros', null, null)">
            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.EXTERNAL.RESERVATIONSINGLE' | translate }}
        </button-link>
        <shared-copyclipboard [value]="getLink('terceros')"></shared-copyclipboard>
    </div>

    <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.SIGN' | translate}}</div>
    <div class="link-with-copy" *ngIf="hardmanUser">
        <button-link class="line left" (linkClick)="onClickLinkOption('signatureEnter', null, null)">
            {{'SHARED.ROUTE.LINKS.CAPTIONS.SIGNONEXIT' | translate}}
        </button-link>
        <shared-copyclipboard [value]="getLink('signatureEnter')"></shared-copyclipboard>
    </div>
    <div class="link-with-copy">
        <button-link class="line left" (linkClick)="onClickLinkOption('signatureExit', null, null)">
            {{'SHARED.ROUTE.LINKS.CAPTIONS.SIGNONENTRY' | translate}}
        </button-link>
        <shared-copyclipboard [value]="getLink('signatureExit')"></shared-copyclipboard>
    </div>

    <div *ngIf="shipments && shipments.length > 0">
        <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.CAPTION' | translate}}</div>

        <div *ngIf="shipments && shipments.length > 1">
            <div *ngFor="let item of shipments" class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('track', item, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.TRACKING' | translate:{ shipmentKey:
                    getString(item.shipmentKey),
                    originSkinAddress: getString(item.originSkinAddress),
                    destinationSkinAddress: getString(item.destinationSkinAddress) } }}
                </button-link>
                <shared-copyclipboard [value]="getLink('track', item)"></shared-copyclipboard>
            </div>
        </div>

        <div *ngIf="shipments && shipments.length == 1">
            <div *ngFor="let item of shipments" class="link-with-copy">
                <button-link class="line left" (linkClick)="onClickLinkOption('track', item, null)">
                    {{ 'SHARED.ROUTE.LINKS.CAPTIONS.SHIPMENT.TRACKINGSINGLE' | translate }}
                </button-link>
                <shared-copyclipboard [value]="getLink('track', item)"></shared-copyclipboard>
            </div>
        </div>
    </div>

    <div class="normal-title">{{'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.CAPTION' | translate}}</div>
    <div class="link-with-copy">
        <button-link class="line left" (linkClick)="onClickLinkOption('totem', null, null)">
            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.IDENTIFY' | translate }}
        </button-link>
        <shared-copyclipboard [value]="getLink('totem')"></shared-copyclipboard>
    </div>
    <div class="link-with-copy">
        <button-link class="line left" (linkClick)="onClickLinkOption('totemEnter', null, null)">
            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.ENTRY' | translate }}
        </button-link>
        <shared-copyclipboard [value]="getLink('totemEnter')"></shared-copyclipboard>
    </div>
    <div class="link-with-copy">
        <button-link class="line left" (linkClick)="onClickLinkOption('totemExit', null, null)">
            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.EXIT' | translate }}
        </button-link>
        <shared-copyclipboard [value]="getLink('totemExit')"></shared-copyclipboard>
    </div>
    <div class="link-with-copy">
        <button-link class="line left" (linkClick)="onClickLinkOption('totemSignature', null, null)">
            {{ 'SHARED.ROUTE.LINKS.CAPTIONS.TOTEM.SIGN' | translate }}
        </button-link>
        <shared-copyclipboard [value]="getLink('totemSignature')"></shared-copyclipboard>
    </div>
</ng-container>